import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// https://github.com/ocombe/ng2-translate/issues/218
export function createTranslateLoader(http) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
const ɵ0 = (createTranslateLoader);
export class AppModule {
}
export { ɵ0 };
